import PlatformEngagement from './platform-engagement';
import GuideDetailToc from './guide-detail-toc';
import type { GuideTocItem } from '../lib/guide-article';
import './post-detail-engagement.css';

export default function PostDetailEngagement({
  gameKey,
  gameDomain,
  postId,
  title,
  tocItems,
}: {
  gameKey: string;
  /** URL 用 domain_key；缺省回退 gameKey */
  gameDomain?: string;
  postId: string;
  title: string;
  tocItems?: GuideTocItem[];
}) {
  const domain = gameDomain || gameKey;
  return (
    <PlatformEngagement
      linkUrl={`/${domain}/guide/${postId}`}
      subject="帖子"
      title={title}
      floatingActions={tocItems && tocItems.length > 0 ? <GuideDetailToc items={tocItems} variant="mobile" /> : undefined}
    />
  );
}
